export default __webpack_public_path__ + "static/media/group_on_ramp.d881d39f.jpg";